module.exports = __webpack_public_path__ + "img/map_Z5.4.A.07.0cc4257c.svg";